export default () => {
    document.body.classList.add('is-loaded');
    const is_touch_enabled = () => { 
        return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (is_touch_enabled()) {
        document.body.classList.add('is-touchable');
    } else {
        document.body.classList.add('is-not-touchable');
    }

    //Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.site_vw = vw * 100;
    window.site_vh = vh * 100;

    if (window.scrollY > 0) {
        document.body.classList.add('is-scrolled');
      } else {
        document.body.classList.remove('is-scrolled');
      }

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
          document.body.classList.add('is-scrolled');
        } else {
          document.body.classList.remove('is-scrolled');
        }
    });

    window.addEventListener('resize', () => {
        // We execute the same script as before
        vw = document.body.clientWidth * 0.01;  
        document.documentElement.style.setProperty('--vw', `${vw}px`);
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.site_vw = vw  * 100;
        window.site_vh = vh  * 100;
    });

    // The debounce function receives our function as a parameter
    const debounce = (fn) => {
        
        // This holds the requestAnimationFrame reference, so we can cancel it if we wish
        let frame;

        // The debounce function returns a new function that can receive a variable number of arguments
        return (...params) => {
            
            // If the frame variable has been defined, clear it now, and queue for next frame
            if (frame) { 
            cancelAnimationFrame(frame);
            }

            // Queue our function call for the next frame
            frame = requestAnimationFrame(() => {
            
            // Call our function and pass any params we received
            fn(...params);
            });

        }
    };

    // Reads out the scroll position and stores it in the data attribute
    // so we can use it in our stylesheets
    const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY;
    }

    // Listen for new scroll events, here we debounce our `storeScroll` function
    document.addEventListener('scroll', debounce(storeScroll), { passive: true });

    // Update scroll position for first time
    storeScroll();


    const emptyAnchors = document.querySelectorAll('a[href="#"]');
    if (emptyAnchors) {
        emptyAnchors.forEach(el => {
            el.addEventListener('click', ev => {
                ev.preventDefault();
            })
        });
    }
}